import {
    Alert,
    Box,
    Card,
    CardContent,
    CardHeader,
    Skeleton,
    Table,
    TableBody, TableCell,
    TableContainer,
    TableHead, TableRow
} from "@mui/material";
import SolicitationTaskDetail from "./SolicitationTaskDetail";
import {ActivityFields, ActivitySolicitation} from "../../../../types/activity/activityData";
import {useEffect, useState} from "react";
import {HttpSolicitationActivities} from "../../../../http/solicitation/httpSolicitation";

interface SolicitationTasksProps {
    solicitationId: number
}


const SolicitationTasks = ({solicitationId}: SolicitationTasksProps) => {
    const [taskList, setTaskList] = useState<ActivitySolicitation[]>()
    const [loading, setLoading] = useState<boolean>(false)
    
    const loadTasks = () => {
        setLoading(true)
        HttpSolicitationActivities.getActivitiesByIdSolicitation(solicitationId).then((r) => {
            const orderedTasks: ActivitySolicitation[] = r.sort((a, b) => {
                return a[ActivityFields.ActivityStateCode] - b[ActivityFields.ActivityStateCode]
            })
            setTaskList(orderedTasks)
            setLoading(false)
        })    
    }
    
    useEffect(() => {
        loadTasks()
    }, [])
    
    return (
        <Card>
            <CardHeader title={'Listado de tareas'}/>
                <CardContent>
                {
                    loading ? Array.from({length: 4}).map((d, i) => <Skeleton key={i}/>)
                        :
                        taskList && (taskList?.length === 0 ? 
                            <Box sx={{width: '100%'}}>
                                <Alert severity={'info'}>Al parecer aun no se cargaron tareas para esta solicitud</Alert>
                            </Box>
                            :
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <TableHead>
                                                        Estado
                                                    </TableHead>
                                                </TableCell>
                                                <TableCell>
                                                    <TableHead>
                                                        # ID
                                                    </TableHead>
                                                </TableCell>
                                                <TableCell>
                                                    <TableHead>
                                                        Tarea
                                                    </TableHead>
                                                </TableCell>
                                                <TableCell>
                                                    <TableHead>
                                                        Fecha Alta
                                                    </TableHead>
                                                </TableCell>
                                                <TableCell>
                                                    <TableHead>
                                                        Última actualización
                                                    </TableHead>
                                                </TableCell>
                                                <TableCell>
                                                    <TableHead>Acciones</TableHead>
                                                </TableCell>
                                            </TableRow>
                                            {taskList.map((task, idx) => <SolicitationTaskDetail task={task} 
                                                                                                                        key={idx}
                                                                                                                        solicitationId={solicitationId}
                                                                                                                        onReload={loadTasks}
                                            />)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                        )
                }
                </CardContent>
        </Card>
    )
}


export default SolicitationTasks